import React, { useEffect } from 'react';

import SEO from "./componets/SEO";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";

import Login from "./componets/login";
import Signup from "./componets/signup";
import ProfilePage from "./componets/profile/ProfilePage";
import OldHomeLayout from "../src/Layouts/OldHomeLayout";
import '@fortawesome/fontawesome-free/css/all.min.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';
import { AUTH } from './redux/const/actionsTypes';
import ForgotPassword from './componets/forgotpassword/ForgotPassword';
import ResetPassword from './componets/resetpassword/ResetPassword';
import SpeakingTest from './Questions/Celpip/SpeakingTest';
import CelpipHome from "./pages/CelpipHome";

import WritingTest from './Questions/Celpip/Writing/WritingTest';
import ReadingTest from './componets/ReadingTest';
import ListeningTest from './componets/ListeningTest';
import Dashboard from './pages/Dashboard';
import Templates from "./pages/Templates";
import WritingTemplateBuilder from "./pages/WritingTemplateBuilder";
import Fulltest from "./pages/fulltest";
import ReadingAttempts from "./componets/ReadingAttempts";
import ListeningAttempts from "./componets/ListeningAttempts";

import WritingChapterDetail from './pages/WritingChapterDetail';
import CelpipReadingPractice from './pages/CelpipReadingPractice';
import AdminPage from './pages/AdminPage';

// PTE Core Imports
import DashboardPTE from "./ptecore/pages/dashboardpte";
import Ptecorereadingtest from "./ptecore/components/ptecorereadingtest.js";
import Ptecorewritingtest from "./ptecore/components/PteCoreWritingTest.tsx";
import PteCoreFullTest from "./ptecore/components/PteCoreFullTest.tsx";
import PteCoreSpeakingTest from "./ptecore/components/PteCoreSpeakingTest.tsx";
import PteCoreListeningTest from "./ptecore/components/PteCoreListeningTest.tsx";
import BuilderPage from "./componets/BuilderPage";


// Next.js owns these slugs — if React SPA accidentally loads one,
// force a full-page navigation to the Next.js server so users never
// see the old React version of these pages.
const NEXTJS_SLUGS = new Set([
    '/', '/canada-pr', '/celpip-full-course',
    '/celpip-listening', '/celpip-listening-course',
    '/celpip-near-me', '/celpip-preparation', '/celpip-reading',
    '/celpip-reading-course', '/celpip-score-calculator', '/celpip-speaking',
    '/celpip-speaking-course', '/celpip-vs-ielts', '/celpip-writing',
    '/contact',
    '/courses', '/about', '/pricing', '/privacy',
    '/pte-core-near-me', '/pte-core-preparation', '/refund', '/terms',
    '/vocabulary', '/what-is-pte-core', '/payment-success', '/payment-cancel',
    '/delete-account', '/blog',
    '/testimonials', '/corporate-training', '/pte-core-mock-test',
    '/classes', '/classes/celpip', '/classes/pte', '/classes/ielts', '/demo',
]);

// Redirects any path with uppercase letters to its all-lowercase equivalent.
// Prevents Google from treating /pricing with mixed case as duplicates.
function LowercaseRedirect() {
    const location = useLocation();
    const lower = location.pathname.toLowerCase();
    if (lower !== location.pathname) {
        // replace: true removes the mixed-case URL from browser history
        return <Navigate to={lower + location.search + location.hash} replace />;
    }
    return null;
}

// If a Next.js-owned route somehow loads inside the React SPA,
// perform a hard redirect so Apache (production) or the Next.js
// dev server (localhost) serves the page instead.
function NextJsGuard() {
    const location = useLocation();
    const slug = location.pathname.replace(/\/+$/, '') || '/';

    const isLocalDev = window.location.hostname === 'localhost'
        || window.location.hostname === '127.0.0.1'
        || window.location.hostname === '[::1]';

    useEffect(() => {
        if (NEXTJS_SLUGS.has(slug)) {
            const queryAndHash = (location.search || '') + (location.hash || '');
            if (isLocalDev) {
                // Local dev: React and Next.js run on different ports.
                // Redirect to the Next.js dev server on port 3000 directly.
                // Synchronize auth to port 3000 if logged in.
                let nextjsUrl = `http://localhost:3000${slug}${queryAndHash}`;
                const storedUser = localStorage.getItem('user_info');
                if (storedUser) {
                    try {
                        const syncParam = `_auth_sync=${encodeURIComponent(btoa(unescape(encodeURIComponent(storedUser))))}`;
                        const sep = nextjsUrl.includes('?') ? '&' : '?';
                        nextjsUrl = `${nextjsUrl}${sep}${syncParam}`;
                    } catch (e) {
                        console.error('Failed to encode dev auth sync', e);
                    }
                }
                if (window.location.href !== nextjsUrl) {
                    window.location.replace(nextjsUrl);
                }
            } else {
                // Production: same-origin redirect — Apache/Nginx will
                // route the request to the Next.js server.
                window.location.replace(`${slug}${queryAndHash}`);
            }
        }
    }, [slug, isLocalDev, location.search, location.hash]);

    if (NEXTJS_SLUGS.has(slug)) {
        return null; // Render nothing while redirecting
    }
    return null;
}

// Add this wrapper component to provide location context to SEO and sync cross-origin dev auth
function AppContent() {
    const location = useLocation();
    const dispatch = useDispatch();

    // Synchronize auth state and test unlocks received from Next.js
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const syncParam = params.get('_auth_sync');
        if (syncParam) {
            try {
                const decoded = decodeURIComponent(escape(atob(decodeURIComponent(syncParam))));
                const parsed = JSON.parse(decoded);
                if (parsed.user_info || parsed.result || parsed._id) {
                    const userInfo = parsed.user_info || (parsed.result ? parsed : { result: parsed });
                    localStorage.setItem('user_info', JSON.stringify(userInfo));
                    dispatch({ type: AUTH, data: userInfo });
                }
                if (parsed.paidTests) {
                    localStorage.setItem('paidTests', JSON.stringify(parsed.paidTests));
                }
                if (parsed.isPaidUser === 'true' || parsed.isPaidUser === true) {
                    localStorage.setItem('isPaidUser', 'true');
                }
                if (parsed.userPackage) {
                    localStorage.setItem('userPackage', parsed.userPackage);
                }
            } catch (err) {
                console.error('[App] Failed to decode incoming _auth_sync:', err);
            }
        }
        if (params.get('paid') === 'true') {
            localStorage.setItem('isPaidUser', 'true');
            localStorage.setItem('paidTests', JSON.stringify(Array.from({ length: 50 }, (_, i) => i + 1)));
        }
    }, [location.search, dispatch]);

    return (
        <>
            {/* Force all paths to lowercase — prevents case-sensitivity duplicate content */}
            <LowercaseRedirect />
            {/* Guard: redirect Next.js-owned routes out of the React SPA */}
            <NextJsGuard />
            {/* SEO now has access to current route */}
            <SEO page={location.pathname} />
            <div className="App">
                <OldHomeLayout />
                <ToastContainer position="top-right" autoClose={3000} />
                <Routes>
                    {/* "/" and all Next.js slugs are handled by NextJsGuard above */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="/profile" element={<ProfilePage />} />
                    <Route path="/upload" element={<Navigate to="/admin" replace />} />
                    <Route path="/celpip" element={<CelpipHome />} />
                    <Route path="/practice" element={<SpeakingTest />} />
                    <Route path="/test" element={<Navigate to="/dashboard" replace />} />
                    <Route path="/writing" element={<WritingTest />} />
                    <Route path="/forgotpassword" element={<ForgotPassword />} />
                    <Route path="/reset-password/:token" element={<ResetPassword />} />
                    <Route path="/reading" element={<ReadingTest />} />
                    <Route path="/listening" element={<ListeningTest />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/reading/:testNumber" element={<ReadingTest />} />
                    <Route path="/templates" element={<Templates />} />                    <Route path="/WritingTemplateBuilder" element={<WritingTemplateBuilder />} />                    <Route path="/listening/:testNumber" element={<ListeningTest />} />
                    <Route path="/writing/:testNumber" element={<WritingTest />} />
                    <Route path="/fulltest" element={<Fulltest />} />
                    <Route path="/fulltest/:testNumber" element={<Fulltest />} />
                    <Route path="/speaking" element={<SpeakingTest />} />
                    <Route path="/speaking/:testNumber" element={<SpeakingTest />} />                    <Route path="/readingattempts" element={<ReadingAttempts />} />
                    <Route path="/listeningattempts" element={<ListeningAttempts />} />                    <Route path="/writing/chapter/:chapterId" element={<WritingChapterDetail />} />
                    <Route path="/pte/dashboardpte" element={<DashboardPTE />} />
                    <Route path="/pte/readingtest/:testNumber" element={<Ptecorereadingtest />} />
                    <Route path="/pte/writingtest/:testNumber" element={<Ptecorewritingtest />} />
                    <Route path="/pte/fulltest/:testNumber" element={<PteCoreFullTest />} />
                    <Route path="/pte/speakingtest/:testNumber" element={<PteCoreSpeakingTest />} />
                    <Route path="/pte/listeningtest/:testId" element={<PteCoreListeningTest />} />
                    <Route path="/builder-preview" element={<BuilderPage />} />
                    <Route path="/celpip-reading-practice" element={<CelpipReadingPractice />} />
                    <Route path="/admin" element={<AdminPage />} />
                </Routes>
            </div>
        </>
    );
}

function App() {
    const dispatch = useDispatch();
    const localUser = JSON.parse(localStorage.getItem("user_info"));
    if (localUser) {
        dispatch({ type: AUTH, data: localUser });
    }

    useEffect(() => {
        window.addEventListener("beforeinstallprompt", (e) => {
            e.preventDefault();
            window.deferredPrompt = e;
        });
    }, []);

    const installApp = async () => {
        const prompt = window.deferredPrompt;
        if (!prompt) return;

        prompt.prompt();
        await prompt.userChoice;
    };

    // Expose it globally on window so other components can trigger the prompt
    window.installApp = installApp;

    // NOTE: BrowserRouter is provided at the top-level (see src/index.js),
    // so do not render another Router here.
    return <AppContent />;
}

export default App;